import { staticFile } from '@common/utils'
import { LazyImage } from '@components/common/image'

const IMAGE_PATH = '/images/school-partnership/benefits/'
const HIGHLIGHT_COLOR = '#FF5A43'

type CardType = {
  title: string
  alt: string
  arrowColor: string
  imageName: string
  isImageLeft: boolean
  imageClass: string
}

const CARD_DATA: CardType[] = [
  {
    title: 'For Schools',
    alt: 'Humans helping each other',
    imageName: 'for-schools',
    arrowColor: 'blue',
    isImageLeft: true,
    imageClass: '',
  },
  {
    title: 'For Teachers',
    alt: 'teacher teaching',
    imageName: 'for-teacher',
    arrowColor: 'red',
    isImageLeft: false,
    imageClass: 'w-5/6',
  },
  {
    title: 'For Students',
    alt: 'students',
    imageName: 'for-students',
    arrowColor: 'green',
    isImageLeft: true,
    imageClass: '',
  },
]

const [SCHOOL_CARD, TEACHER_CARD, STUDENT_CARD] = [0, 1, 2]

const CardHeading = ({ heading }) => (
  <div className="relative flex flex-col">
    <LazyImage
      alt="Card heading background"
      name="heading-bg"
      path={IMAGE_PATH}
      className="absolute top-0 bottom-0 right-0 left-0 w-40 lg:w-48"
    />
    <span className="relative text-grey text-2xl lg:text-3xl font-500 lg:font-600 pt-2 pl-2">
      {heading}
    </span>
  </div>
)

const CardPointer = ({ index, children }) => (
  <div className="flex">
    <img
      src={staticFile(`${IMAGE_PATH + CARD_DATA[index].arrowColor}-arrow.svg`)}
      className="self-start mr-3 ml-2 lg:w-8"
      alt="pointer arrow"
    />
    <div className="my-2 lg:my-0 lg:mb-4 lg:text-xl">{children}</div>
  </div>
)

const Card = ({ index, children }) => (
  <div
    className={`flex flex-col ${
      CARD_DATA[index].isImageLeft ? 'lg:flex-row' : 'lg:flex-row-reverse'
    } m-5 p-2 shadow-lg lg:shadow-none rounded-lg lg:items-center lg:justify-between`}
  >
    <div className="lg:w-1/3">
      <LazyImage
        alt={CARD_DATA[index].alt}
        name={CARD_DATA[index].imageName}
        path={IMAGE_PATH}
        className={`mx-auto ${CARD_DATA[index].imageClass}`}
      />
    </div>
    <div className="lg:w-2/3 lg:px-8">
      <CardHeading heading={CARD_DATA[index].title} />
      <div className="py-5 font-600 text-grey">{children}</div>
    </div>
  </div>
)

const Benefits = () => (
  <div className="relative overflow-hidden pt-20 lg:pt-8 pb-2 lg:pb-8">
    <LazyImage
      path={IMAGE_PATH}
      name="left-shapes"
      className="hidden lg:flex absolute top-5 left-5 w-32"
      alt="Background left shapes"
    />
    <LazyImage
      path={IMAGE_PATH}
      name="right-shapes"
      className="hidden lg:flex absolute top-5 right-5 w-56"
      alt="Background right shapes"
    />
    <div className="relative z-10 max-w-6xl mx-auto">
      <h1 className="text-center font-700 text-4xl leading-tight text-grey mx-5 lg:mx-auto mb-5">
        Benefits of Partnering with us
      </h1>
      <div className="flex flex-col">
        <Card index={SCHOOL_CARD}>
          <CardPointer index={SCHOOL_CARD}>
            Customised{' '}
            <span style={{ color: HIGHLIGHT_COLOR }}>
              Coding Curriculum designed
            </span>{' '}
            for each school.
          </CardPointer>
          <CardPointer index={SCHOOL_CARD}>
            <span style={{ color: HIGHLIGHT_COLOR }}>
              Computer science graduate teachers from Codingal
            </span>{' '}
            with vast industry and academic experience available.
          </CardPointer>
          <CardPointer index={SCHOOL_CARD}>
            <span style={{ color: HIGHLIGHT_COLOR }}>Master dashboard</span> to
            track the performance of students and school teachers.
          </CardPointer>
        </Card>
        <Card index={TEACHER_CARD}>
          <CardPointer index={TEACHER_CARD}>
            <span style={{ color: HIGHLIGHT_COLOR }}>Training</span> provided to
            school teachers by{' '}
            <span style={{ color: HIGHLIGHT_COLOR }}>
              Codingal Knowledge Experts
            </span>{' '}
            on curriculum, platforms, and programming languages suitable for all
            grade groups.
          </CardPointer>
          <CardPointer index={TEACHER_CARD}>
            <span style={{ color: HIGHLIGHT_COLOR }}>Custom dashboard</span> to
            track and review the performance of each student
          </CardPointer>
          <CardPointer index={TEACHER_CARD}>
            <span style={{ color: HIGHLIGHT_COLOR }}>
              Speakership / Advocate
            </span>{' '}
            opportunity at Codingal Events.
          </CardPointer>
        </Card>
        <Card index={STUDENT_CARD}>
          <CardPointer index={STUDENT_CARD}>
            <span style={{ color: HIGHLIGHT_COLOR }}>Lifetime access</span> to a
            personal dashboard with{' '}
            <span style={{ color: HIGHLIGHT_COLOR }}>
              lessons, projects, coding quizzes,
            </span>{' '}
            and <span style={{ color: HIGHLIGHT_COLOR }}>STEM.org</span>{' '}
            accredited certificates.
          </CardPointer>
          <CardPointer index={STUDENT_CARD}>
            Regular Parent-Teacher Meetings and doubt sessions.
          </CardPointer>
          <CardPointer index={STUDENT_CARD}>
            Free participation in{' '}
            <span style={{ color: HIGHLIGHT_COLOR }}>
              global coding competitions and hackathons,
            </span>{' '}
            hosted with{' '}
            <span style={{ color: HIGHLIGHT_COLOR }}>
              IIT Bombay, Hewlett-Packard Enterprise,
            </span>{' '}
            and others.
          </CardPointer>
        </Card>
      </div>
    </div>
  </div>
)

export default Benefits
